module.exports = (s) => {
  return {
    parent_game_ids: {
      label: '游戏',
      type: 'select-tree',
      props: {
        options: [],
        ischeckbox: false,
        'check-on-click-node': true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children',
        },
        'select-props': {
          placeholder: '请选择游戏',
          size: 'mini',
          clearable: true,
          accordion: true,
        },
      },
      on: {
        getValue: (parent_game_ids) => {
          s.table_filter.parent_game_ids.value = parent_game_ids;
        },
      },
      value: null,
    },
    keyword: {
      label: '关键词',
      type: 'input',
      props: {
        placeholder: '请输入关键词搜索',
      },
      value: '',
    },
    level: {
      label: '标签等级',
      type: 'select',
      options: [
        {
          label: '一级标签',
          value: 1,
        },
        {
          label: '二级标签',
          value: 2,
        },
      ],
      props: {
        placeholder: '请选择标签等级',
      },
      value: '',
    },
  };
};
